// Formats an amount (number or string) nicely.
// Examples:
// formatAmount(123) => "123.00"
// formatAmount(123456) => "12,3456.00"
// formatAmount(12345678) => "12.34M"
// formatAmount(12345678, false) => "12,345,678.00"
// formatAmount(12345678, false, 0) => "12,345,678"
export const formatAmount = (
  value: number | string,
  compact: boolean = true,
  minDecimals: number = 2,
  maxDecimals: number = 2,
  compactZero: boolean = true,
  compactThreshold: number = 1_000_000
) => {
  if (typeof value === "string") {
    value = parseFloat(value)
  }
  if (value === 0 && compactZero) {
    return "0"
  }
  if (value < 0.1 && parseFloat(value.toFixed(maxDecimals)) === 0 && compactZero) {
    return "0"
  }
  // Compact the number if requested (never compact thousands) otherwise return full amount with commas
  return Intl.NumberFormat("en", {
    notation: compact && value >= compactThreshold ? "compact" : undefined,
    minimumFractionDigits: compact && value >= compactThreshold ? 0 : minDecimals,
    maximumFractionDigits: maxDecimals,
  }).format(value)
}

export const formatPercentage = (value: number, decimals: number = 2) => (value * 100).toFixed(decimals) + "%"
